/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_CustomerInputs */

const en_samples_customer = /** @type {(inputs: Samples_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer`)
};

const es_samples_customer = /** @type {(inputs: Samples_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente`)
};

/**
* | output |
* | --- |
* | "Customer" |
*
* @param {Samples_CustomerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_customer = /** @type {((inputs?: Samples_CustomerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_CustomerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_customer(inputs)
	return es_samples_customer(inputs)
});